import AutoplayController from "~/lib/autoplay_controller"
import { replay, tween } from "~/lib/motion"

// Add to cart opens the "You just added" popup; the shopper takes an offer
export default class extends AutoplayController {
  static targets = ["product", "addButton", "popup", "subtotal", "offerButton"]

  reset() {
    this.productTarget.hidden = false
    this.popupTarget.hidden = true
    this.subtotalTarget.textContent = "$35.00"
    this.offerButtonTarget.classList.remove("is-done")
    this.offerButtonTarget.textContent = "Add to cart"
  }

  async play(wait) {
    await wait(700)
    await this.click(this.addButtonTarget, wait)
    await wait(200)
    this.productTarget.hidden = true
    this.popupTarget.hidden = false
    replay(this.popupTarget, "is-pop")

    await wait(1300)
    await this.click(this.offerButtonTarget, wait)
    this.offerButtonTarget.classList.add("is-done")
    this.offerButtonTarget.textContent = "Added ✓"
    tween(this.subtotalTarget, 35, 46.9)
  }
}
